import React from 'react'
import {
  EditOutlined,
  FieldNumberOutlined,
  FormOutlined,
  UnorderedListOutlined,
  MenuOutlined,
  CheckSquareOutlined,
  GroupOutlined,
  CalendarOutlined,
  FieldTimeOutlined,
  CopyOutlined,
} from '@ant-design/icons'

const EditorIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" width="24px" height="24px"
  ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
  <g id="SVGRepo_iconCarrier"> 
  <path d="M7.2 21C6.07989 21 5.51984 21 5.09202 20.782C4.71569 20.5903 4.40973 20.2843 4.21799 19.908C4 19.4802 4 18.9201 4 17.8V6.2C4 5.07989 4 4.51984 4.21799 4.09202C4.40973 3.71569 4.71569 3.40973 5.09202 3.21799C5.51984 3 6.0799 3 7.2 3H16.8C17.9201 3 18.4802 3 18.908 3.21799C19.2843 3.40973 19.5903 3.71569 19.782 4.09202C20 4.51984 20 5.0799 20 6.2V7M8 7H14M8 15H9M8 11H12M11.1954 20.8945L12.5102 20.6347C13.2197 20.4945 13.5744 20.4244 13.9052 20.2952C14.1988 20.1806 14.4778 20.0317 14.7365 19.8516C15.0279 19.6486 15.2836 19.393 15.7949 18.8816L20.9434 13.7332C21.6306 13.0459 21.6306 11.9316 20.9434 11.2444C20.2561 10.5571 19.1418 10.5571 18.4546 11.2444L13.2182 16.4808C12.739 16.96 12.4994 17.1996 12.3059 17.4712C12.1341 17.7123 11.9896 17.9717 11.8751 18.2447C11.7461 18.5522 11.6686 18.882 11.5135 19.5417L11.1954 20.8945Z" stroke="#000000" 
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
  )


const fieldTypeIcons = [
  {
    id: 'info-box',
    type: 'new',
    icon: EditorIcon,
    title: 'Info Box',
  },
  {
    id: 'single-input',
    type: 'new',
    icon: EditOutlined,
    title: 'Text',
  },
  {
    id: 'numeric-input',
    type: 'new',
    icon: FieldNumberOutlined,
    title: 'Numeric',
  },
  {
    id: 'text-area-field',
    type: 'new',
    icon: FormOutlined,
    title: 'Long Text',
  },
  {
    id: 'radio-button',
    type: 'new',
    icon: UnorderedListOutlined,
    title: 'Radio Buttons',
  },
  {
    id: 'dropdown',
    type: 'new',
    icon: MenuOutlined,
    title: 'Dropdown',
  },
  {
    id: 'checkboxes',
    type: 'new',
    icon: CheckSquareOutlined,
    title: 'Checkboxes',
  },
  {
    id: 'multiselect',
    type: 'new',
    icon: GroupOutlined,
    title: 'Multiselect',
  },
  {
    id: 'date-input',
    type: 'new',
    icon: CalendarOutlined,
    title: 'Date',
  },
  {
    id: 'time-input',
    type: 'new',
    icon: FieldTimeOutlined,
    title: 'Time',
  },
  {
    id: 'templated',
    type: 'new',
    icon: CopyOutlined,
    title: 'Templated',
  },
]

export default fieldTypeIcons
